import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Timeline.scss';

const Timeline = ({
    seperator,
    heading,
    icon,
    children,
    elements,
    hasEmbeddedHeading,
    ...otherProps
}) => {
    var cssClass = classNames({
        timeline: true,
        hasSeperator: seperator
    });

    return (
        <div>
            <div className={cssClass}>
                <div className="description">
                    {seperator ? <div className="seperator">{seperator.toUpperCase()}</div> : null}
                    <div className="heading">{heading}</div>
                    <div className="center">{icon}</div>
                </div>
                <div className="content">
                    <div {...otherProps} className="children">
                        {children}
                    </div>
                    <div>{elements}</div>
                </div>
            </div>
        </div>
    );
};

Timeline.propTypes = {
    seperator: PropTypes.string,
    heading: PropTypes.string,
    children: PropTypes.any.isRequired
};

export default Timeline;



// WEBPACK FOOTER //
// ./src/components/Timeline/Timeline.jsx